export default "__VITE_ASSET__DVSn2Lc2__"